import React from 'react';
import { useDataPresentationParam } from '@/hooks';
import { EditQuery as EditQueryBase } from '../buttons';
import { useNavigateToDataPresentation } from './useNavigateToDataPresentation';

export const EditQuery = () => {
  const dataPresentation = useDataPresentationParam();
  const navigate = useNavigateToDataPresentation();

  return <EditQueryBase onClick={navigate} $active={!dataPresentation} />;
};
